import { render, staticRenderFns } from "./count.vue?vue&type=template&id=89607ab0&scoped=true"
import script from "./count.vue?vue&type=script&lang=js"
export * from "./count.vue?vue&type=script&lang=js"
import style0 from "./count.vue?vue&type=style&index=0&id=89607ab0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89607ab0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89607ab0')) {
      api.createRecord('89607ab0', component.options)
    } else {
      api.reload('89607ab0', component.options)
    }
    module.hot.accept("./count.vue?vue&type=template&id=89607ab0&scoped=true", function () {
      api.rerender('89607ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/platformManagement/legalManagement/count.vue"
export default component.exports